// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".judgement-template-select-tab .box-footer[data-v-86a8d7da]{padding:10px 0 0 0!important}.judgement-template-select-tab .box-footer .update-btn[data-v-86a8d7da]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
